<template>
    <UCard class="rounded-t-sm mx-0.5 p-2" :ui="{root: 'rounded-none', body: 'sm:p-2'}">
        <div class="flex gap-4 z-40">
            <USelect
                v-model="selectedStatus"
                class="min-w-36"
                placeholder="Velg status"
                value-key="value"
                label-key="label"
                :items="statusOptions"
                @update:model-value="handleChangeStatus"
            />
            <USelect
                v-model="selectedCategory"
                class="min-w-36"
                placeholder="Velg kategori"
                value-key="value"
                label-key="label"
                :items="categoryOptions"
                :ui="{
                    content: 'w-max',
                }"
                @update:model-value="handleChangeCategory"
            />
            <UInput
                v-model="searchTerm"
                placeholder="Søk i oppgaver"
                class="flex-1 min-w-[200px] max-w-[400px]"
                icon="i-ph-magnifying-glass"
                @keyup="debouncedEmit"
            />
        </div>
    </UCard>
</template>

<script setup lang="ts">

import {debounce} from 'lodash'
import {ref} from 'vue'
import {useAssignmentOptions} from '@/assignments/Assignment.options'

const {statusOptions, categoryOptions} = useAssignmentOptions({includeAll: true})

const defaultStatus = statusOptions.value[1]

const searchTerm = ref<string>('')
const selectedStatus = ref(defaultStatus.value)
const selectedCategory = ref(undefined)

const emit = defineEmits(['onSearchTermUpdated', 'onStatusSelected', 'onCategorySelected'])

const emitChange = () => {
    emit('onSearchTermUpdated', searchTerm.value)
}
const debouncedEmit = debounce(emitChange, 500)

const handleChangeStatus = (status: String) => {
    const statusFilter = status !== 'all' ? {
        status: {
            filterType: 'text',
            type: 'equals',
            filter: status
        },
    } : {}

    emit('onStatusSelected', statusFilter)
}

const handleChangeCategory = (category: String) => {
    const categoryFilter = category !== 'all' ? {
        type: {
            filterType: 'text',
            type: 'equals',
            filter: category
        }
    } : {}

    emit('onCategorySelected', categoryFilter)
}

</script>

<style scoped>

</style>